__turbopack_context__.v({
  "body": "CapabilitiesLong-module-scss-module__3_5x9q__body",
  "capabilities": "CapabilitiesLong-module-scss-module__3_5x9q__capabilities",
  "capabilitiesLong": "CapabilitiesLong-module-scss-module__3_5x9q__capabilitiesLong",
  "eyebrow": "CapabilitiesLong-module-scss-module__3_5x9q__eyebrow",
  "eyebrowDivider": "CapabilitiesLong-module-scss-module__3_5x9q__eyebrowDivider",
  "eyebrowRow": "CapabilitiesLong-module-scss-module__3_5x9q__eyebrowRow",
  "header": "CapabilitiesLong-module-scss-module__3_5x9q__header",
  "headline": "CapabilitiesLong-module-scss-module__3_5x9q__headline",
  "inner": "CapabilitiesLong-module-scss-module__3_5x9q__inner",
  "item": "CapabilitiesLong-module-scss-module__3_5x9q__item",
  "itemList": "CapabilitiesLong-module-scss-module__3_5x9q__itemList",
  "stack-module-0": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-0",
  "stack-module-1": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-1",
  "stack-module-10": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-10",
  "stack-module-11": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-11",
  "stack-module-12": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-12",
  "stack-module-13": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-13",
  "stack-module-14": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-14",
  "stack-module-15": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-15",
  "stack-module-16": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-16",
  "stack-module-17": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-17",
  "stack-module-18": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-18",
  "stack-module-19": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-19",
  "stack-module-2": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-2",
  "stack-module-20": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-20",
  "stack-module-3": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-3",
  "stack-module-4": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-4",
  "stack-module-5": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-5",
  "stack-module-6": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-6",
  "stack-module-7": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-7",
  "stack-module-8": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-8",
  "stack-module-9": "CapabilitiesLong-module-scss-module__3_5x9q__stack-module-9",
  "z-base": "CapabilitiesLong-module-scss-module__3_5x9q__z-base",
  "z-content": "CapabilitiesLong-module-scss-module__3_5x9q__z-content",
  "z-footer": "CapabilitiesLong-module-scss-module__3_5x9q__z-footer",
  "z-header": "CapabilitiesLong-module-scss-module__3_5x9q__z-header",
  "z-hero": "CapabilitiesLong-module-scss-module__3_5x9q__z-hero",
  "z-logo": "CapabilitiesLong-module-scss-module__3_5x9q__z-logo",
  "z-logo-effect": "CapabilitiesLong-module-scss-module__3_5x9q__z-logo-effect",
  "z-navigation": "CapabilitiesLong-module-scss-module__3_5x9q__z-navigation",
  "z-sub": "CapabilitiesLong-module-scss-module__3_5x9q__z-sub",
});
